
import { defineComponent } from 'vue'
import border from '@/assets/imgs/border.gif'

export default defineComponent({
  name: 'ActionBtn',
  props: {
    block: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      border
    }
  }
})
